import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSurveyAnswers } from '../lib/api';

export type UpdateAnswersFormValues = {
  surveyId: string;
  version: number;
  answersId: string;
  answers: Record<string, unknown>;
  answeredByUserId: string;
  checkupsToAdd?: string[];
};

// useSaveAnswers is a hook that returns a mutation function to save the answers for a survey.
export const useUpdateAnswers = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync: updateAnswers,
    isPending,
    error
  } = useMutation({
    mutationFn: async ({
      surveyId,
      version,
      answersId,
      answeredByUserId,
      answers,
      checkupsToAdd
    }: UpdateAnswersFormValues) => {
      await updateSurveyAnswers(surveyId, version, answersId, answers, answeredByUserId, checkupsToAdd);
      await queryClient.invalidateQueries({
        queryKey: ['survey-answers', answersId]
      });
    }
  });

  return {
    updateAnswers,
    isPending,
    error
  };
};
